<template>
  <div class="position_relative">
    <div class="padding_content" id="padding_appInsight">
      <div id="appinsight_container">
        <div class="app_selection">
          <img src="../../assets/img/search-appinsight.png" alt="" />
          <h3>{{ $t('service.appService') }}</h3>
          <div class="color_gray color_gray2">{{ $t('service.freetip') }}</div>
          <div class="color_gray">{{ $t('service.each') }}</div>
          <div class="uploadBox">
            <div class="fileBox">
              {{ $t('service.upload') }}
              <input
                type="file"
                id="myFile"
                class="inputfile"
                @change="handlerUpload($event)"
                :disabled="show"
              />
            </div>
            <p class="max_apk"><i class="icon-apk"></i>{{ $t('service.max') }}</p>
            <ul
              class="files"
              v-if="(files && files.length > 0) || (appDataList && appDataList.length > 0)"
            >
              <div>
                <li
                  v-for="(file, index) in files"
                  class="files_li"
                  v-if="showFiles && files"
                  :key="index"
                >
                  <div v-if="index === 0">
                    <div class="screen_max">
                      <span class="files_date">{{ file.date }}</span>
                      <span class="files_name">{{ file.name }}</span>
                      <span
                        class="color_completed"
                        v-if="status === 'completed'"
                        @click="jump(link)"
                        >{{ $t('service.report') }}</span
                      >
                      <span class="color_loading" v-if="status === 'processing'"
                        ><i class="el-icon-loading"></i
                      ></span>
                      <span class="color_failed" v-if="status === 'failed'">{{ desc }}</span>
                    </div>
                    <div class="screen_min">
                      <div>
                        <span class="files_name">{{ file.name }}</span>
                        <div class="min_right">
                          <span class="files_date">{{ file.date }}</span>
                          <span
                            class="color_completed"
                            v-if="status === 'completed'"
                            @click="jump(link)"
                            >{{ $t('service.report') }}</span
                          >
                          <span class="color_loading" v-if="status === 'processing'"
                            ><i class="el-icon-loading"></i
                          ></span>
                          <span class="color_failed" v-if="status === 'failed'">{{ desc }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li v-for="(file, index) in appDataList" class="files_li">
                  <div v-if="index < 5">
                    <div class="screen_max">
                      <span class="files_date">{{ file.localTime }}</span>
                      <span class="files_name">{{ file.name }}</span>
                      <span
                        class="color_completed"
                        v-if="file.status === 'completed'"
                        @click="jump(file.link)"
                        >{{ $t('service.report') }}</span
                      >
                      <span class="color_loading" v-if="file.status === 'processing'"
                        ><i class="el-icon-loading"></i
                      ></span>
                      <span class="color_failed" v-if="file.status === 'failed'">{{
                        file.desc
                      }}</span>
                    </div>
                    <div class="screen_min">
                      <div>
                        <span class="files_name">{{ file.name }}</span>
                        <div class="min_right">
                          <span class="files_date">{{ file.localTime }}</span>
                          <span
                            class="color_completed"
                            v-if="file.status === 'completed'"
                            @click="jump(file.link)"
                            >{{ $t('service.report') }}</span
                          >
                          <span class="color_loading" v-if="file.status === 'processing'"
                            ><i class="el-icon-loading"></i
                          ></span>
                          <span class="color_failed" v-if="file.status === 'failed'">{{
                            file.desc
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
            <div
              class="files_noData"
              v-if="files && files.length === 0 && appDataList && appDataList.length === 0"
            >
              <img src="../../assets/img/no_search.png" alt="" />
              <p>{{ $t('dashboard.noData') }}</p>
            </div>
          </div>
        </div>
        <div v-if="product.appInsights">
          <h3 class="choose">{{ $t('service.choose') }}</h3>
          <div
            class="better_suits"
            v-if="product.appInsights.apiPlans && product.appInsights.apiPlans.length > 0"
          >
            <p>{{ $t('service.apkLevel') }}</p>
            <div class="product_list">
              <div
                class="product_li"
                v-for="(item, index) in product.appInsights.apiPlans"
                :key="index"
              >
                <img
                  :src="lang === 'en' ? recommendedImg1 : recommendedImg2"
                  alt=""
                  v-if="item.tag == 'recommended'"
                  class="recommended"
                />
                <img
                  :src="lang === 'en' ? subscribedImg1 : subscribedImg2"
                  alt=""
                  v-if="item.tag == 'subscribed'"
                  class="recommended"
                />
                <div v-if="item.discountPrice">
                  <h3 class="new_price"><span>$</span>{{ item.discountPrice }}</h3>
                  <h3 class="old_price"><span>$</span>{{ item.originalPrice }}</h3>
                </div>
                <h3 class="new_price" v-if="!item.discountPrice">
                  <span>$</span>{{ item.originalPrice }}
                </h3>
                <p class="way">
                  {{ lang === 'en' ? item.type : formatTypes(item.type) || item.type }}
                </p>
                <div v-if="lang === 'en' && item.description.en">
                  <div class="description">
                    <p v-for="(ditem, dindex) in item.description.en" :key="dindex">{{ ditem }}</p>
                  </div>
                  <div
                    class="select_btn"
                    @click="
                      jump2(
                        'Android Dynamic & Static Analysis Report',
                        item.planId,
                        item.discountPrice,
                        item.originalPrice,
                        item.type,
                        item.description.en
                      )
                    "
                    v-if="item.tag !== 'subscribed'"
                  >
                    {{ $t('service.select') }}
                  </div>
                  <div class="select_btn subscribe_btn" v-if="item.tag == 'subscribed'">
                    <el-button type="text" @click="open(item.subId)">{{
                      $t('service.unsubscribe')
                    }}</el-button>
                  </div>
                </div>
                <div v-if="lang === 'zh' && item.description.zh">
                  <div class="description">
                    <p v-for="(ditem, dindex) in item.description.zh" :key="dindex">{{ ditem }}</p>
                  </div>
                  <div
                    class="select_btn"
                    @click="
                      jump2(
                        'Android Dynamic & Static Analysis Report',
                        item.planId,
                        item.discountPrice,
                        item.originalPrice,
                        item.type,
                        item.description.zh
                      )
                    "
                    v-if="item.tag !== 'subscribed'"
                  >
                    {{ $t('service.select') }}
                  </div>
                  <div class="select_btn subscribe_btn" v-if="item.tag == 'subscribed'">
                    <el-button type="text" @click="open(item.subId)">{{
                      $t('service.unsubscribe')
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <serviceFooter @scale="scale"></serviceFooter>
    <loading :show="loading"></loading>
  </div>
</template>

<script>
  import serviceFooter from './footer2'
  import loading from '../../components/loading'
  import axios from 'axios'
  import { Message } from 'element-ui'
  import { common } from '@/views/public/common'
  import { downAPP } from '../public/validator'
  import VueRouter from 'vue-router'

  const { isNavigationFailure, NavigationFailureType } = VueRouter

  export default {
    name: 'AppInsight',
    components: { common, serviceFooter, loading },
    data() {
      return {
        loading: true,
        files: [],
        uploadSuccess: 0,
        appDataList: [],
        show: false,
        hover: false,
        status: 'processing',
        link: '',
        errDesc: '',
        showFiles: false,
        email: '',
        product: [],
        recommendedImg1: require('../../assets/img/mark-recommended.png'),
        recommendedImg2: require('../../assets/img/recommended-zh.png'),
        subscribedImg1: require('../../assets/img/mark-subscribed.png'),
        subscribedImg2: require('../../assets/img/subscribed-zh.png')
        // file.uploadStatus=-1 出错啦，请重新上传或者删除
        // file.uploadStatus=1 上传中...
        // file.uploadStatus=2 已上传
        // file.uploadStatus=-2 出错啦，文件类型不符合要求
        // file.uploadStatus=-3 出错啦，文件大小超出限制
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      formatDate: common.formatDate,
      scale(val) {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
        if (val) {
          document.getElementById('padding_appInsight').style.paddingBottom = '150px'
        } else {
          document.getElementById('padding_appInsight').style.paddingBottom = '73px'
        }
        if (val && document.documentElement.clientWidth < 450 && isiOS) {
          document.getElementById('padding_appInsight').style.paddingBottom = '250px'
        }
        if (!val && document.documentElement.clientWidth < 450 && isiOS) {
          document.getElementById('padding_appInsight').style.paddingBottom = '170px'
        }
      },
      outStyle() {
        this.hover = false
      },
      selectStyle() {
        this.hover = true
      },
      close() {
        this.files = false
      },
      handlerUpload: function(e) {
        // 获取选定的文件
        let tFiles = e.target.files
        let len = tFiles.length
        for (var i = 0; i < len; i++) {
          // 开始上传每一个文件
          var item = {
            name: tFiles[i].name,
            uploadPercentage: 1,
            size: this.formatFileSize(tFiles[i].size, 0),
            uploadStatus: 0,
            date: this.formatDate(new Date())
          }
          // console.log(item)
          // 开始上传文件 新建一个formData
          let param = new FormData()
          // param.append("name", "wiiiiiinney");
          // 通过append向form对象添加数据
          param.append('uploadFile', tFiles[i])
          param.append('localTime', this.formatDate(new Date()))
          // FormData私有类对象，访问不到，可以通过get判断值是否传进去
          // console.log(param.get("uploadFile"));

          // 通过axios上传文件
          // 配置
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            // 添加上传进度监听事件
            onUploadProgress: e => {
              var completeProgress = (((e.loaded / e.total) * 100) | 0) + '%'
              console.log('this.files in onUploadProgress', this.files)
              item.uploadPercentage = completeProgress
            }
          }
          if (this.checkFileType(tFiles[i].name.split('.')[tFiles[i].name.split('.').length - 1])) {
            this.show = true
            this.files.push(item)
            this.files = this.files.reverse()
            this.showFiles = true
            this.status = 'processing'
            axios
              .post('/api/app-insights/submit', param, config)
              .then(res => {
                this.show = false
                item.uploadStatus = 2
                this.$socket.emit('register', this.email)
              })
              .catch(err => {
                console.log('error: ', err)
                Message({ type: 'error', message: err, showClose: true })
                item.uploadStatus = -1
                this.show = false
              })
          } else {
            item.uploadStatus = -2
            return false
          }
        }
      },
      formatFileSize: function(fileSize, idx) {
        var units = ['B', 'KB', 'MB', 'GB']
        idx = idx || 0
        if (fileSize < 1024 || idx === units.length - 1) {
          return fileSize.toFixed(1) + units[idx]
        }
        return this.formatFileSize(fileSize / 1024, ++idx)
      },
      checkFileType: function(fileType) {
        const acceptTypes = ['apk']
        for (var i = 0; i < acceptTypes.length; i++) {
          if (fileType === acceptTypes[i]) {
            return true
          }
        }
        Message({ type: 'error', message: this.$t('service.errType'), showClose: true })
        return false
      },
      getServiceData() {
        axios
          .get('/api/product')
          .then(res => {
            this.loading = false
            this.product = res.data
          })
          .catch(err => {
            this.loading = false
            Message({
              type: 'error',
              message: err.response.data.statusCode + ' ' + err.response.data.message,
              showClose: true
            })
          })
      },
      jump(link) {
        // window.open(link, "_blank");
        let query = {
          link: link
        }
        this.$router.push({ path: '/reportDetail', query: query }).catch(err => {
          // to hide the below error message
          if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            throw Error(err)
          }
        })
      },
      jump2(service, planId, discountPrice, originalPrice, type, description) {
        let query = {
          service: service,
          planId: planId,
          discountPrice: discountPrice,
          originalPrice: originalPrice,
          type: type,
          description: description
        }
        this.$router.push({ path: '/payment', query: query }).catch(err => {
          // to hide the below error message
          if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            throw Error(err)
          }
        })
      },
      getUser() {
        axios
          .get('/api/user')
          .then(res => {
            this.email = res.data.email
            this.appDataList = res.data.app_insights_trail_history
            this.appDataList = this.appDataList.reverse()
          })
          .catch(err => {})
      },
      open(subId) {
        this.$confirm(this.$t('message.appUnsubscribe'), this.$t('message.confirm'), {
          confirmButtonText: this.$t('message.UNSUBSCRIBE'),
          cancelButtonText: this.$t('message.CANCEL'),
          customClass: 'modal_messageBox'
        })
          .then(() => {
            this.changeUnsubscribe(subId)
          })
          .catch(() => {})
      },
      changeUnsubscribe(subId) {
        let data = {
          subId: subId
        }
        axios
          .post('/api/unsubscribe', data)
          .then(res => {
            Message({ type: 'success', message: 'Unsubscribed successfully', showClose: true })
            this.getServiceData()
          })
          .catch(err => {
            Message({
              type: 'error',
              message: err.response.data.statusCode + ' ' + err.response.data.message,
              showClose: true
            })
          })
      },
      formatTypes: common.formatTypes
    },
    mounted() {
      this.getUser()
      this.getServiceData()
      downAPP('padding_appInsight', '170px')
    },
    // MEMO: if you use "nodemon", sockets won't work
    sockets: {
      appInsights(data) {
        console.log({ data })
        this.showFiles = false
        this.getUser()
        this.status = data.status
        if (data.status === 'failed') {
          this.errDesc = data.desc
          Message({ type: 'error', message: data.status, showClose: true })
        }
        if (data.status === 'completed') {
          this.link = data.link
          Message({ type: 'success', message: data.status, showClose: true })
        }
      }
    }
  }
</script>

<style lang="scss" src="./service.scss" scoped></style>
<style lang="scss" scoped>
  ::v-deep .el-icon-close {
    cursor: pointer;
  }
  .app_selection {
    height: 370px;
    @include border-radius(6px);
    background: $white;
    position: relative;
    text-align: center;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
    & > h3 {
      width: 100%;
      height: 24px;
      font-size: 20px;
      font-family: NexaBold;
      color: rgba(31, 37, 62, 1);
      line-height: 24px;
      padding: 40px 0 8px;
    }
    & > img {
      width: 140px;
      height: 140px;
      @include absolute-left-top(0, 0);
    }
    .color_gray {
      height: 15px;
      font-size: 12px;
      font-family: NexaLight;
      font-weight: 400;
      color: rgba(31, 37, 62, 0.7);
      line-height: 15px;
      margin-bottom: 32px;
    }
    .color_gray2 {
      margin-bottom: 10px;
    }
    .fileBox {
      width: 170px;
      height: 40px;
      line-height: 40px;
      @include border-radius(30px);
      border: 1px solid $primary-color;
      color: $primary-color;
      margin: 0 auto;
      text-align: center;
      position: relative;
      font-size: 16px;
      font-family: Metropolis-SemiBold;
      font-weight: 600;
      cursor: pointer;
      &:hover {
        background: $primary-color;
        color: $white;
        box-shadow: 0px 4px 16px 0px rgba(255, 103, 0, 0.3);
      }
      #myFile {
        width: 170px;
        height: 40px;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
      }
    }
    .max_apk {
      font-size: 12px;
      font-family: Lato-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 15px;
      margin: 8px auto 37px;
      height: 15px;
      .icon-apk {
        color: rgba(153, 153, 153, 1);
        margin-right: 4px;
      }
    }
    .files {
      @include flex-justify-center;
      text-align: left;
      .files_li {
        margin-bottom: 5px;
        font-size: 12px;
        font-family: Lato-Regular;
        font-weight: 400;
        line-height: 15px;
        .screen_min {
          display: none;
        }
        .files_date {
          color: rgba(31, 37, 62, 0.6);
        }
        .files_name {
          color: rgba(31, 37, 62, 1);
          margin: 0 10px;
          word-break: break-word;
        }
        .color_completed {
          color: #19b432;
          cursor: pointer;
        }
        .color_failed {
          color: #ed0c0c;
        }
      }
    }
    .files_noData {
      & > img {
        width: 70px;
        height: 70px;
      }
      & > p {
        height: 12px;
        line-height: 23px;
        font-size: 12px;
        color: $primary-color;
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 450px) {
    .app_selection {
      height: auto;
      min-height: 384px;
      box-sizing: border-box;
      padding: 0 20px 20px;
      & > img {
        width: 60px;
        height: 60px;
      }
      & > h3 {
        font-size: 14px;
        padding: 40px 0 12px;
        height: auto;
        box-sizing: border-box;
      }

      .color_gray {
        height: auto;
        margin-bottom: 24px;
      }

      .files {
        display: block;
        .files_li {
          margin-bottom: 0;
          .files_name {
            height: auto;
            text-align: left;
            margin: 0;
            max-width: 60%;
          }
          .files_date,
          .color_completed,
          .color_loading,
          .color_failed {
            display: block;
            height: 15px;
            width: 130px;
          }
          .color_file {
            margin-top: 4px;
          }
          .screen_max {
            display: none;
          }
          .screen_min {
            display: block;
            box-sizing: border-box;
            & > div {
              padding: 5px 0;
              @include flex-space-center;
              border-bottom: 1px solid rgba(243, 246, 254, 1);
              .min_right {
                height: 34px;
                text-align: right;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/service/app.vue